import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { CheckCircle2 } from "lucide-react";
import { BoltIcon } from "../components/Bolts";

const OrderSuccessPage = () => {
    const { clear } = useCart();

    // The order is paid — the cart's job is done, so empty it.
    useEffect(() => {
        clear();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div data-testid="order-success-page" className="min-h-[70vh] flex items-center justify-center container-x py-20">
            <div className="text-center max-w-md">
                <CheckCircle2 className="w-14 h-14 text-storm-bolt mx-auto mb-5" />
                <p className="eyebrow flex items-center justify-center gap-2 mb-3">
                    <BoltIcon className="w-3.5 h-3.5" /> Order Confirmed
                </p>
                <h1 className="text-3xl md:text-4xl text-white mb-4 leading-tight">
                    Thanks for your order.
                </h1>
                <p className="text-storm-mist mb-8">
                    Payment received — we'll get started right away. A receipt has been sent to your email.
                </p>
                <Link to="/" data-testid="order-success-home" className="btn-primary inline-flex">
                    Back to shop
                </Link>
            </div>
        </div>
    );
};

export default OrderSuccessPage;
